<template>
<!-- <v-card v-model="model">test</v-card> -->
  <v-autocomplete
      :items="items"
      :label="label"
      @change="onInput"
      v-model="model"
      color="primary"
      clearable
      class="subtitle-2 font-weight-medium"
    ></v-autocomplete>
</template>
<script>
export default {
  name: 'text-select',
  data () {
    return {
      model: this.value
    }
  },
  methods: {
    onInput () {
      this.$emit('input', this.model)
    }
  },
  props: {
    value: {},
    label: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array
    }
  }
}
</script>
